import { FaFacebookF, FaInstagram, FaXTwitter, FaYoutube } from "react-icons/fa6"
import { useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import useActiveNavbar from '../hook/useActiveNavbar';

const products = [
    {
        name: "Mobile App",
        link: "/#mobile-app",
    }
];

const resources = [
    {
        name: "Help Center",
        link: "/help"
    },
    {
        name: "Tutorials",
        link: "/tutorial"
    },
    {
        name: "Blogs",
        link: "/blog"
    },
];


const company = [
    {
        name: "FAQ",
        link: "/faq"
    },
    {
        name: "Contact Us",
        link: "/contact-us"
    }
];

const legal = [
    {
        name: "Terms & Conditions",
        link: "/terms-of-service"
    },
    {
        name: "Privacy Policy",
        link: "/privacy-policy"
    }
];

const Footer = () => {
    const { selected, setSelected }: any = useActiveNavbar();
    const location = useLocation();

    useEffect(() => {
        setSelected(location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    const hideHeaderForAdmin = "admin";
    const hideHeaderForSuperAdmin = "superadmin";
    // const hideHeaderForMember = "member";
    const hideHeaderForPageNotFound = "not-found";
    const hideHeaderForUnAuthorised = "un-authorized";
    const hideHeaderForVisitor = "visitors";
    if (location.pathname.replace("/", "").startsWith(hideHeaderForAdmin)
        || location.pathname.replace("/", "").startsWith(hideHeaderForSuperAdmin)
        // || location.pathname.replace("/", "").startsWith(hideHeaderForMember)
        || location.pathname.replace("/", "").includes(hideHeaderForPageNotFound)
        || location.pathname.replace("/", "").includes(hideHeaderForUnAuthorised)
        || location.pathname.replace("/", "").includes(hideHeaderForVisitor)
    ) {
        return <></>;
    }

    const handleMobileAppClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (location.pathname === "/") {
            e.preventDefault();

            const element = document.getElementById("mobile-app");

            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });

                window.history.replaceState(null, "", "#mobile-app");
            }
        }
    };

    return (
        <footer className="bg-[#0B121E] px-4 md:px-[46px] pt-[40px] pb-[10px]">
            <div className="w-full">

                {/* TOP SECTION */}
                <div className="pb-[35px] flex flex-col lg:flex-row gap-10 lg:gap-20 items-start lg:items-center justify-between">

                    {/* LOGO + DESCRIPTION */}
                    <div className="flex w-full flex-col text-center lg:text-left gap-3 max-w-full lg:max-w-sm">
                        <NavLink to="/">
                            <img
                                className="logo-img w-[140px] md:w-[185px] h-auto mx-auto lg:mx-0"
                                src="/images/navbar_logo.png"
                                alt="logo"
                            />
                        </NavLink>

                        <p className="text-[#CCCCCC] text-[13px] md:text-[14px] leading-relaxed">
                            Empowering churches with modern tools to connect,
                            engage, and grow stronger communities.
                        </p>
                    </div>


                    <div className="max-md:w-full grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-32">

                        <div>
                            <h4 className="text-[15px] md:text-[16px] font-medium mb-2 text-[#FFFFFF]">Products</h4>
                            <ul className="space-y-2 text-[14px]">
                                {products.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`w-fit hover:underline cursor-pointer hover:text-primary ${selected === item.link ? "text-secondary" : "text-[#CCCCCC]"
                                            }`}
                                    >
                                        <NavLink
                                            to={item.link}
                                            onClick={item.link === "/#mobile-app" ? handleMobileAppClick : undefined}
                                        >
                                            {item.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-[15px] md:text-[16px] font-medium mb-2 text-[#FFFFFF]">Resources</h4>
                            <ul className="space-y-2 text-[14px]">
                                {resources.map((item, index) => (
                                    <li key={index} className={`w-fit hover:underline cursor-pointer hover:text-primary ${selected === item.link ? "text-secondary" : "text-[#CCCCCC]"}`}>
                                        <NavLink to={item.link}>{item.name}</NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>


                        <div>
                            <h4 className="text-[15px] md:text-[16px] font-medium mb-2 text-[#FFFFFF]">Company</h4>
                            <ul className="space-y-2 text-[14px]">
                                {company.map((item, index) => (
                                    <li key={index} className={`w-fit hover:underline cursor-pointer ${selected === item.link ? "text-secondary" : "text-[#CCCCCC]"} hover:text-primary`}>
                                        <NavLink to={item.link}>{item.name}</NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>


                        <div>
                            <h4 className="text-[15px] md:text-[16px] font-medium mb-2 text-[#FFFFFF]">Legal</h4>
                            <ul className="space-y-2 text-[14px]">
                                {legal.map((item, index) => (
                                    <li key={index} className={`w-fit hover:underline cursor-pointer hover:text-primary ${selected === item.link ? "text-secondary" : "text-[#CCCCCC]"}`}>
                                        <NavLink to={item.link}>{item.name}</NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </div>
                </div>


                <div className="border-t border-[#D0D0D0] p-[15px] flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">


                    <p className="text-white text-sm font-medium">
                        ©  My Church Directory {new Date().getFullYear()}. All right reserved
                    </p>

                    <div className="flex items-center gap-4">
                        <a
                            href="https://www.youtube.com/@MyChurchDirectory"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaYoutube className="cursor-pointer text-white hover:text-secondary" />
                        </a>

                        <a
                            href="https://www.facebook.com/profile.php?id=61591713422514"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaFacebookF className="cursor-pointer text-white hover:text-secondary" />
                        </a>

                        <a
                            href="https://www.instagram.com/mycdir/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaInstagram className="cursor-pointer text-white hover:text-secondary" />
                        </a>

                        <a
                            href="https://x.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaXTwitter className="cursor-pointer text-white hover:text-secondary" />
                        </a>
                    </div>
                </div>

            </div>
        </footer>
    )
}

export default Footer;